import { Thermostat, ThermostatComfortSetting } from '@/types'

function getThermostatComfortSettingsForPortal(
  comfortSettings: ThermostatComfortSetting[],
  portal: Thermostat['portal'],
) {
  if (comfortSettings.length === 0) {
    return []
  }

  if (portal === 'Nest') {
    return [comfortSettings[0]]
  }

  return comfortSettings
}

function getComfortSettingShiftDescription(
  comfortSetting: ThermostatComfortSetting,
): string {
  const heatDelta =
    comfortSetting.event_heat_setpoint_delta ??
    comfortSetting.event_default_setpoint_delta
  const coolDelta =
    comfortSetting.event_cool_setpoint_delta ??
    comfortSetting.event_default_setpoint_delta

  if (heatDelta && coolDelta) {
    return `Shift by -${heatDelta} for heat and +${coolDelta} for AC`
  }
  if (heatDelta) {
    return `Shift by -${heatDelta} for heat`
  }
  if (coolDelta) {
    return `Shift by +${coolDelta} for AC`
  }
  return 'No shift'
}

export function getGridSupportSettingsSummary(
  comfortSettings: ThermostatComfortSetting[],
  thermostat: Thermostat,
): {
  label?: string
  description?: string
}[] {
  const settings = getThermostatComfortSettingsForPortal(
    comfortSettings,
    thermostat.portal,
  )

  if (settings.length === 1) {
    return [
      {
        description: getComfortSettingShiftDescription(settings[0]),
      },
    ]
  }

  return settings.map((setting) => ({
    label: setting.name,
    description: getComfortSettingShiftDescription(setting),
  }))
}
